export const skills = [
  {
    title: "Languages",
    items: "Python, JavaScript, Java"
  },
  {
    title: "Web",
    items: "NodeJS, ExpressJS, ReactJS, HTML/CSS, Redux, Flask, Django, Spring Boot"
  },
  {
    title: "Cloud",
    items: "AWS, Microsoft Azure, Google Cloud"
  },
  {
    title: "Database & Storage",
    items: "MySQL, PostgreSQL, Firebase, MongoDB, Redis"
  },
  {
    title: "Unix/ Linux",
    items: "VMs, Command-Line, Bash, Shell Scripting, Vi"
  },
  {
    title: "VCS & DevOps",
    items: "Git, Terraform, Ansible, Docker, Kubernetes, TeamCity, Github Actions, Jenkins"
  },
  {
    title: "Communication Protocols",
    items: "HTTP, TCP/IP, REST"
  },
  {
    title: "Testing & Best Practices",
    items: "Unit Testing, Integration Testing, Test-Driven Development (TDD), Load Testing"
  }
]



// WEBPACK FOOTER //
// ./src/skill-data.js